module.exports = __webpack_public_path__ + "static/img/loading.ade619a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 44